module.exports = __webpack_public_path__ + "img/@work_img4.9e85de6d.jpg";